import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";

import { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";

import LeadScoreChip from "../LeadScoreChip/LeadScoreChip";

import { StyledEmptyTooltipHeader, StyledTooltipHeader, StyledTooltipHeaderText } from "./styles";

const SCORE_STATUS_TEXT_CONFIG: Readonly<Record<LeadPriorityScore, { text: string; color: string } | undefined>> = {
    [LeadPriorityScore.High]: {
        text: "si.lead_score_agent.status_text.high",
        color: colorsPalettes.torquoise[50],
    },
    [LeadPriorityScore.Medium]: {
        text: "si.lead_score_agent.status_text.medium",
        color: colorsPalettes.yellow[100],
    },
    [LeadPriorityScore.Low]: {
        text: "si.lead_score_agent.status_text.low",
        color: colorsPalettes.blue[50],
    },
    [LeadPriorityScore.Unlock]: undefined,
    [LeadPriorityScore.NoScore]: undefined,
};

interface IProps {
    score: LeadPriorityScore;
}

const LeadScoreTooltipStatusHeader = ({ score }: IProps): ReactElement => {
    const { translate } = useTranslate();

    const status = SCORE_STATUS_TEXT_CONFIG[score];

    if (!status) {
        return (
            <StyledEmptyTooltipHeader>
                <LeadScoreChip score={score} />
            </StyledEmptyTooltipHeader>
        );
    }

    return (
        <StyledTooltipHeader
            gap="8px"
            alignItems="center"
            backgroundColor={status.color}
        >
            <LeadScoreChip score={score} />
            <StyledTooltipHeaderText
                fontVariant="primaryItem"
                color={colorsPalettes.bluegrey[600]}
            >
                {translate(status.text)}
            </StyledTooltipHeaderText>
        </StyledTooltipHeader>
    );
};

export default LeadScoreTooltipStatusHeader;
